export default {
  title: 'Nebula buds AI通话',
  userID: '用户ID : ',
  hurryUp: '等待对方呼叫',
  waitingCall: '在此页面等待对方拨打电话，请勿提前关闭。',
  subSwitch: '字幕开关',
  initWait: '等待初始化',
  initSuccess: '初始化完成，等待对方呼叫。请勿关闭页面！',
  callStart: '电话接通',
  callEnd: '通话结束',
  careful: '注意 : ',
  wait: '通话组件已准备好,等待对方拨打电话',
  langSwitch: {
    ar: '阿拉伯语',
    da: '丹麦语',
    de: '德语',
    en: '英语',
    es: '西班牙语',
    fil: '菲律宾语',
    fr: '法语',
    hi: '印地语',
    id: '印度尼西亚语',
    it: '意大利语',
    ja: '日文',
    ko: '韩语',
    ms: '马来语',
    no: '挪威语',
    pt: '葡萄牙语',
    ru: '俄语',
    sv: '瑞典语',
    th: '泰语',
    tr: '土耳其语',
    vi: '越南语',
    zh: '中文'
  }
}
